import { render, staticRenderFns } from "./DayLimitTab.vue?vue&type=template&id=1ecf1d17"
import script from "./DayLimitTab.vue?vue&type=script&lang=js"
export * from "./DayLimitTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports